export default function getCssColorPropertyValue(name: string) {
  const style = getComputedStyle(document.body);
  return style.getPropertyValue(name);
}
